import { applyMiddleware, createStore } from "redux";
import reducer from "./reducers/reducer";
import thunk from "redux-thunk";
import { historyMiddleware } from "./middleware/historyMiddleware";

export const storeRedux= createStore(reducer, applyMiddleware(thunk,historyMiddleware))

export default storeRedux;
